enum ReleaseStatus {
    open = 'open',
    closed = 'closed'
}

export default ReleaseStatus
